import { useCallback, useEffect, useMemo, useState } from "react";
import { ChatIcon } from "../../components/icons/Icon";
import Button from "../../components/updatedComponents/Dealers/Button";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import styles from "./Orders.module.css";
import { useAuth } from "../../components/context/Auth";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SaleOrder from "./SaleOrder";
import PurchaseOrder from "./PurchaseOrder";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import AdjustmentOrder from "./AdjustmentOrder";
import VerticalDropDown from "../../components/updatedComponents/FormComponents/VerticalDropDown";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Transfer from "./Transfer";
import Production from "./Production";
import ProductionSale from "./ProductionSale";
import ProductionTransfer from "./ProductionTransfer";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { formatDateTime, getStatusColor } from "../../Utils/Utils";
import { CryptoDecrypt } from "../../Utils/TextUtils";
import MasterOrder from "./MasterOrder";
import DirectCollect from "./DirectCollect";

const Order = () => {
  const { mode, designations } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { route } = useParams();
  let isNew = false;
  isNew = location.search === "" ? true : false;

  const [isDefaultCase, setIsDefaultCase] = useState(false);
  const [orderType, setOrderType] = useState(isNew && "Sales");
  //same but for mobile
  const [selectedOrderType, setSelectedOrderType] = useState(
    isNew && {
      label: "Sales",
      value: "Sales",
    },
  );
  const [orderData, setOrderData] = useState({});
  const [managerAuth, setManagerAuth] = useState({});

  useEffect(() => {
    const encrypted = localStorage.getItem("orderManagerAuth");

    if (encrypted) {
      try {
        // const bytes = CryptoJS.AES.decrypt(encrypted, "secret key");
        const decrypted = JSON.parse(CryptoDecrypt(encrypted));

        setManagerAuth(decrypted);
      } catch (error) {
        console.error("Failed to decrypt managerAuth:", error);
      }
    }
  }, []);

  // const canCreateDirectCollect = managerAuth?.directCollectAccess;
  // const canCreateMasterOrder = managerAuth?.masterOrderAccess;

  // console.log(route, "pathname", location.pathname);

  useEffect(() => {
    if (route === "saleorder" || location.pathname.includes("saleorder")) {
      setOrderType("Sales");
    }
    if (route === "purchase" || location.pathname.includes("purchase")) {
      setOrderType("Purchase");
    }
    if (route === "adjustment" || location.pathname.includes("adjustment")) {
      setOrderType("Adjustment");
    }
    if (route === "transfer" || location.pathname.includes("transfer")) {
      setOrderType("Transfer");
    }
    if (
      route === "directcollect" ||
      location.pathname.includes("directcollect")
    ) {
      setOrderType("Direct Collect");
    }
    if (route === "masterorder" || location.pathname.includes("masterorder")) {
      setOrderType("Master Order");
    }
  }, [location.pathname, route]);

  const orderTypeChange = (label) => {
    const selectedFilter = orderTypeData.find((item) => item === label);
    setOrderType(selectedFilter || "Sales");
  };

  const handleOrderData = useCallback((data) => {
    setOrderData(data);
  }, []);

  // let orderTypeData = [
  //   "Sales",
  //   "Collection",
  //   "Purchase",
  //   "Adjustment",
  //   "Transfer",
  //   "Production",
  //   "Production & Sale",
  //   "Production & Transfer",
  //   "Direct Collect",
  //   "Master Order",
  // ];

  // const designationOptionsMap = useMemo(
  //   () => ({
  //     inventorymanager: orderTypeData,
  //     superadmin: orderTypeData,
  //     ordermanager: ["Sales", "Collection", "Production & Sale"],
  //     default: ["Sales"],
  //   }),
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [],
  // );

  let orderTypeData = [
    "Sales",
    "Collection",
    "Purchase",
    "Adjustment",
    "Transfer",
    "Production",
    "Production & Sale",
    "Production & Transfer",
    "Direct Collect",
    "Master Order",
  ];
  const designationOptionsMap = useMemo(() => {
    let ALL_ORDER_TYPES = [
      "Sales",
      "Collection",
      "Purchase",
      "Adjustment",
      "Transfer",
      "Production",
      "Production & Sale",
      "Production & Transfer",
      "Direct Collect",
      "Master Order",
    ];
    const base = ["Sales", "Collection", "Production & Sale"];

    const orderManagerOptions = [
      ...base,
      ...(managerAuth?.directCollectAccess ? ["Direct Collect"] : []),
      ...(managerAuth?.masterOrderAccess ? ["Master Order"] : []),
    ];

    return {
      inventorymanager: ALL_ORDER_TYPES,
      superadmin: ALL_ORDER_TYPES,
      ordermanager: orderManagerOptions,
      default: ["Sales"],
    };
  }, [managerAuth]);

  const getAllowedOrderTypes = useCallback(
    (designations) => {
      if (!designations || designations.length === 0) {
        setIsDefaultCase(true);
        return designationOptionsMap.default;
      }

      const allowedTypes = new Set(designationOptionsMap.default);

      designations.forEach((designation) => {
        if (designationOptionsMap[designation]) {
          designationOptionsMap[designation].forEach((type) =>
            allowedTypes.add(type),
          );
        }
      });

      return Array.from(allowedTypes);
    },
    [designationOptionsMap],
  );

  orderTypeData = useMemo(() => {
    return getAllowedOrderTypes(designations);
  }, [designations, getAllowedOrderTypes]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (isNew) {
        const allowedOrderTypes = getAllowedOrderTypes(designations);

        const orderTypeMapping = {
          F1: "Sales",
          F2: "Collection",
          F3: "Purchase",
          F4: "Adjustment",
          F5: "Transfer",
          F6: "Production",
          F7: "Production & Sale",
          F8: "Production & Transfer",
          F9: "Direct Collect",
          F10: "Master Order",
        };

        if (
          e.key.startsWith("F") &&
          !isNaN(e.key.slice(1)) &&
          e.key.length > 1
        ) {
          e.preventDefault();
        }

        const selectedType = orderTypeMapping[e.key];
        if (selectedType && allowedOrderTypes.includes(selectedType)) {
          setOrderType(selectedType);
          setSelectedOrderType({ label: selectedType, value: selectedType });
        }
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [designations, getAllowedOrderTypes, isNew]);

  const topText1 = orderType === "Sales" ? "Sale Order" : orderType || "";
  const topText2 = orderData?.orderId ? ` / ${orderData.orderId}` : "";
  const topText = isNew ? topText1 : `${topText1}${topText2}`;

  return (
    <div
      className={`${styles.order}`}
      style={mode ? { backgroundColor: "#2C2E33", border: "none" } : {}}
    >
      <div className={styles.order_top}>
        <div className={styles.order_top_left}>
          <TopTabBar text={topText} />
        </div>
        <div className={styles.order_right}>
          {isNew ? (
            <div style={{ display: isDefaultCase && "none" }}>
              <div className={styles.order_sf}>
                <SlidingFilter2
                  itemList={orderTypeData.map((item) => item)}
                  setFilter={orderTypeChange}
                  selectedItem={orderTypeData.find(
                    (item) => item === orderType,
                  )}
                />
              </div>
              <div className={styles.order_dd_mob}>
                <VerticalDropDown
                  height={"37px"}
                  fontSize={"12px"}
                  onchange={(option) => {
                    setSelectedOrderType(option);
                    setOrderType(option.value);
                  }}
                  value={selectedOrderType}
                  options={orderTypeData.map((o) => ({ label: o, value: o }))}
                />
              </div>
            </div>
          ) : orderData?.loading ? (
            <div style={{ width: "20rem" }}>
              <Skeleton
                lines={1}
                thickness={50}
                additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
              />
            </div>
          ) : (
            <div className={styles.right}>
              <TextElement
                label={"Voucher No. & Date:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={
                  orderData?.orderId +
                  " / " +
                  formatDateTime(orderData?.orderDate)
                }
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"12px"}
                type={"order"}
              />
              {(orderType === "Sales" ||
                orderType === "Master Order" ||
                orderType === "Direct Collect") && (
                <TextElement
                  label={"Created By:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={orderData?.createdBy}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"12px"}
                  type={"order"}
                />
              )}
              {(orderType === "Sales" ||
                orderType === "Master Order" ||
                orderType === "Direct Collect") && (
                <TextElement
                  label={"Order Manager:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={orderData?.orderManagerName || "In Dev."}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"12px"}
                  type={"order"}
                />
              )}
              {(orderType === "Sales" ||
                orderType === "Master Order" ||
                orderType === "Direct Collect") && (
                <TextElement
                  label={"Source:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={orderData?.type}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"12px"}
                  type={"order"}
                />
              )}
              {(orderType === "Sales" ||
                orderType === "Master Order" ||
                orderType === "Direct Collect") && (
                <TextElement
                  label={"Status:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={orderData?.status}
                  valueColor={getStatusColor(orderData?.status)}
                  fontSize={"12px"}
                  type={"order"}
                />
              )}
            </div>
          )}

          {isNew && (
            <div>
              <Button
                buttonIcon={<ChatIcon />}
                buttonText={"Chat"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#ffffff"}
                buttonBorder={"none"}
                buttonClick={() => {
                  navigate("/whatsappchats");
                }}
              />
            </div>
          )}
        </div>
      </div>

      {orderType === "Sales" && <SaleOrder onOrderData={handleOrderData} />}
      {orderType === "Collection" && <h1>Work Under Progress</h1>}
      {orderType === "Purchase" && (
        <PurchaseOrder onOrderData={handleOrderData} />
      )}
      {orderType === "Adjustment" && (
        <AdjustmentOrder onOrderData={handleOrderData} />
      )}
      {orderType === "Transfer" && <Transfer onOrderData={handleOrderData} />}
      {orderType === "Production" && <Production />}
      {orderType === "Production & Sale" && <ProductionSale />}
      {orderType === "Production & Transfer" && <ProductionTransfer />}
      {orderType === "Direct Collect" && (
        <DirectCollect onOrderData={handleOrderData} />
      )}
      {orderType === "Master Order" && (
        <MasterOrder onOrderData={handleOrderData} />
      )}
    </div>
  );
};

export default Order;
